
import { Auth0Organization } from "@/lib/auth/User";
import { TypedVue } from "@/store/types";
import { Component } from "vue-property-decorator";

@Component({})
export default class SelectOrganization extends TypedVue {
  public organizations: Auth0Organization[] = [];
  public selectedOrganziation: Auth0Organization | null = null;
  public searchText = "";

  get sortedOrganizations() {
    const filtered = this.searchText ? this.organizations.filter((org) => org.display_name.toLowerCase().includes(this.searchText.toLowerCase())) : this.organizations;
    return filtered.sort((a, b) => a.display_name.localeCompare(b.display_name));
  }

  async mounted() {
    this.organizations = this.$auth.user?.organizations || [];

    if (this.organizations.length === 1) {
      await this.pickOrg(this.organizations[0]);
    }
  }

  async pickOrg(org: Auth0Organization) {
    this.selectedOrganziation = org;

    try {
      await this.$auth.getTokenSilently({ organization: org.id, ignoreCache: true });
    } catch (e) {
      await this.$auth.loginWithRedirect({ organization: org.id });
    }

    await this.$router.replace("/admin/summary");
  }
}
